export default __webpack_public_path__ + "static/media/mw.4a846883.svg";